import { useEffect } from "react";
import { createContext, useState, useContext } from "react";
import SocketContext from "./SocketContext";

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const Socket = useContext(SocketContext);
  const InitialState = window.Branding || {
    Id: 1,
    Name: "Exista Business Solutions LLC",
    CompanyName: "Exista Business Solutions LLC",
    Contact: {
      Phone: "tel:201015471713",
      WhatsApp: "https://wa.me/201148371185",
      FaceBook: "https://www.facebook.com/futuresolutionsdev",
    },
  };
  const [Branding, setBranding] = useState(InitialState);
  const OnChange = (Key, Value) => {
    console.log({
      Key,
      Value,
    });
    if (Key == "Id") {
      localStorage.setItem("Id", Value);
    }
    if (typeof Key == "object") {
      setBranding((prev) => ({
        ...prev,
        ...Key,
      }));
      return;
    }
    setBranding((prev) => ({
      ...prev,
      [Key]: Value,
    }));
  };
  // Page Title
  useEffect(() => {
    let Name = Branding.Name || InitialState?.Name;
    if (document.title != Name) {
      document.title = `${Branding.Name || InitialState?.Name} `;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Branding.Name]);
  useEffect(() => {
    const HandleBranding = (data) => {
      if (data?.data) {
        const { Name } = data.data;
        console.log("Branding", data);
        if (typeof OnChange == "function") OnChange("Name", Name);
      }
    };
    if (Socket) {
      Socket.on("Branding", HandleBranding);
      return () => {
        Socket.off("Branding", HandleBranding);
      };
    }
  }, [Socket]);
  const value = {
    ...Branding,
    OnChange,
  };
  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useBranding = () => {
  return useContext(BrandingContext);
};
